module.exports = __webpack_public_path__ + "static/media/payroll.7fe8f29a.svg";